import React from "react";
import "./footer.scss";

import { t } from "i18next";
import { Stack } from "react-bootstrap";

const Footer = () => {
  return (
    <div className="p-5">
      <Stack
        direction="horizontal"
        className="w-100  d-flex justify-content-center align-items-center footer-invitation py-2"
        gap={4}
      >
        <a href="/privacy-policy">{t("privacy_policy.title")}</a>
        <a href="/term-of-use">{t("term_of_use.title")}</a>
      </Stack>
    </div>
  );
};

export default Footer;
